<template>
  <div class="addproject-step2">
    <v-btn v-if="!hideControls" color="primary" class="ml-1" fab dark elevation="0" small @click="addPosition()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <div class="row mt-1">
      <div v-for="(h, ind) in headers" :key="ind" class="project-position-header" :class="h.cl">
        {{ h.name }}
      </div>
    </div>
    <!-- {{curProject.positions}} -->
    <div v-for="(pos, ind) in curProject.positions" :key="ind" class="row">
      <div :class="headers[0].cl">
        <v-select :value="pos.role_id" :items="roles" @change="onInput(ind, 'role_id', $event)"
          item-value="id" item-text="name" :menu-props="{ offsetY: true }" outlined dense :readonly="hideControls" :hide-details="hideControls"
          :error-messages="fieldErrors(ind, 'role_id')"
        />
      </div>
      <div :class="headers[1].cl">
        <v-select :value="pos.level_id" :items="levels" @change="onInput(ind, 'level_id', $event)"
          item-value="id" item-text="name" :menu-props="{ offsetY: true }" outlined dense :readonly="hideControls" :hide-details="hideControls"
          :error-messages="fieldErrors(ind, 'level_id')"
        />
      </div>
      <div :class="headers[2].cl">
        <v-textarea :value="pos.tasks" @input="onInput(ind, 'tasks', $event)" class="position-textarea" :readonly="hideControls" :hide-details="hideControls"
          :error-messages="fieldErrors(ind, 'tasks')" outlined dense auto-grow rows="3"
        />
      </div>
      <div :class="headers[3].cl">
        <v-textarea :value="pos.competenses" @input="onInput(ind, 'competenses', $event)" class="position-textarea" :readonly="hideControls" :hide-details="hideControls"
          :error-messages="fieldErrors(ind, 'competenses')" outlined dense auto-grow rows="3"
        />
      </div>
      <div v-if="!hideControls" class="d-flex justify-center" :class="headers[4].cl">
        <v-btn icon small @click="onRemovePosition(ind)">
          <v-icon color="error">mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="!hideControls" class="d-flex justify-end mt-8 mb-3 mr-8">
      <v-btn @click="back()" color="primary" outlined class="mr-3 px-13">Назад</v-btn>
      <v-btn @click="next()" color="primary" class="px-13">Далее</v-btn>
    </div>
    <AskDialog v-model="showDeleteDialog" @ok="removePosition(curInd)" />

  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators'
import AskDialog from "@/components/ui/AskDialog"

export default {
  name: 'ProjectStep2',
  components: {
    AskDialog
  },
  props:{
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showErrors: false,
      curInd: 0,
      showDeleteDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      curProject: 'ai/hrprojects/curProject',
      roles: 'ai/hrprojects/roles',
      levels: 'ai/hrprojects/levels',
      loading: 'ai/hrprojects/loading',
    }),
    headers() {
      let base = [
        { name: 'Роль', cl: 'project-col-4-4' },
        { name: 'Уровень', cl: 'project-col-4-4' },
        { name: 'Ключевые задачи', cl: 'project-col-4-4' },
        { name: 'Ключевые навыки', cl: 'project-col-4-4' },
      ]
      if (!this.hideControls) {
        base = base.map(h => ({ ...h, cl: 'project-col-4-5' }))
        base.push({ name: '', cl: 'project-col-action' })
      }
      return base
    }
  },
  validations() {
    const positionValidations = {
        role: { required },
        level: { required },
        tasks: { required },
        competenses: { required },
      }
      const positionRules = (this.curProject.positions || []).map(() => positionValidations)
      return {
        curProject: {
        positions: positionRules
      }
    } 
 },  
  methods: {
    ...mapMutations({
      addPosition: 'ai/hrprojects/addPosition',
      removePosition: 'ai/hrprojects/removePosition',
    }),
    onRemovePosition(ind) {
      this.showDeleteDialog = true
      this.curInd = ind
    },
    validatePositions() {
      let valid = true
      for (const pos of this.curProject.positions) {
        if (!pos.role_id || !pos.level_id || !pos.tasks || !pos.competenses) {
          valid = false
          break
        }
      }
      return valid
    },    
    onInput(ind, field, value) {
      this.curProject.positions[ind][field] = value
    },
    fieldErrors(ind, field) {
      const pos = this.curProject.positions[ind]
      return !pos[field] && this.showErrors ? ['Обязательное поле'] : []      
    },
    clearRange() {
      this.range = [];
      this.datePickerShow = false;
    },
    back() {
      this.$emit('back')
    },
    next() {
      this.showErrors = true
      if (!this.validatePositions()) {
        this.$toast?.error('Пожалуйста, заполните все поля', '', { position: 'topRight' })
        return
      }
      this.$emit('next')
    },
  }
};
</script>

<style lang="scss" _scoped>

.addproject-step2 {
  width: 1200px;
  max-width: 100%;
}

.project-position-header {
  font-weight: 600;
  color: #333
  // text-align: center;
}

.position-textarea textarea{
  font-weight: 400;
  font-size: 13px;
  line-height: 130% !important;
}

.project-col-4-5 {
  padding: 12px;
  flex: 0 0 calc((100% - 80px) / 4);
  width: calc((100% - 80px) / 4); /* 4 колонки + 5 отступов */
}

.project-col-4-4 {
  padding: 12px;
  flex: 0 0 calc((100% - 40px) / 4);
  width: calc((100% - 40px) / 4); // 4 колонки + 3 промежутка
}

.project-col-action {
  padding: 12px;
  width: 40px;
  flex: 0 0 40px;
}

</style>

